import { Button, useToast } from '@chakra-ui/react';
import React from 'react';

import { useCommitArtifactDocumentAndCreditAgreementsMutation } from '../../requests/requests.gql.generated';
import { IconButton } from 'packages/common-frontend/components/IconButton';
import { GET_CREDIT_AGREEMENT_DOCUMENTS_METADATA } from 'packages/creditAgreements/requests/requests.gql';
import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';
import { FiCheckSquare } from 'react-icons/fi';

type CommitCreditAgreementWipButtonProps = {
  creditFacilityId: string;
  isDisabled: boolean;
  operationMode: CreditAgreement.OperationMode;
  onCommitDone: () => void;
};
export const CommitCreditAgreementWipButton = ({
  isDisabled,
  operationMode,
  creditFacilityId,
  onCommitDone,
}: CommitCreditAgreementWipButtonProps) => {
  const toast = useToast();

  const [
    commitArtifactDocumentAndCreditAgreements,
    { loading: isCommitLoading },
  ] = useCommitArtifactDocumentAndCreditAgreementsMutation({
    onCompleted: ({ commitArtifactDocumentAndCreditAgreements: result }) => {
      result.successes.forEach((success) => {
        toast({
          title: success,
          position: 'top',
          status: 'success',
          duration: null, // this is important information, do not auto-close.
          isClosable: true,
        });
      });

      result.errors.forEach((errors) => {
        toast({
          title: errors,
          position: 'top',
          status: 'error',
          duration: null, // this is important information, do not auto-close.
          isClosable: true,
        });
      });

      if (!result.errors.length) {
        onCommitDone();
      }
    },
    onError: () => {
      toast({
        title: `Error committing credit agreement document wip.`,
        position: 'top',
        status: 'error',
        duration: null, // this is important information, do not auto-close.
        isClosable: true,
      });
    },
    refetchQueries: [
      {
        query: GET_CREDIT_AGREEMENT_DOCUMENTS_METADATA,
        variables: { creditFacilityId },
      },
    ],
  });

  const isAdminOperationMode = operationMode === 'admin';

  const handleOnClick = () => {
    return commitArtifactDocumentAndCreditAgreements({
      variables: {
        creditFacilityId,
      },
    });
  };

  if (isAdminOperationMode) {
    return (
      <IconButton
        onClick={handleOnClick}
        isDisabled={isDisabled}
        isLoading={isCommitLoading}
        icon={<FiCheckSquare />}
        ariaLabel="Commit"
        label="Commit"
      />
    );
  }

  return (
    <Button
      aria-label="Commit"
      colorScheme="aurora"
      variant="outline"
      backgroundColor="white"
      padding="10px 24px"
      borderWidth="2px"
      onClick={handleOnClick}
      isDisabled={isDisabled}
      isLoading={isCommitLoading}
    >
      Commit Configuration
    </Button>
  );
};
